import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpProvider {
  public getUrl(): Observable<string> {
    return of('https://solo.mcr-symphony.net/symphonysolo/api/');
  }
}
